import React from "react";
import "./HeroSection.style.css"; // استایل‌های کامپوننت
import HeroImage from "../../assets/images/hero-02.jpg";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <section className="hero-section">
      {/* تصویر پس‌زمینه */}
      <div className="hero-background">
        <img src={HeroImage} alt="Hero Background" />
      </div>

      {/* محتوای روی تصویر */}
      <div className="hero-content">
        <Link to="/drop">
          <button className="hero-button">ورود به دراپ</button>
        </Link>
      </div>
    </section>
  );
};

export default HeroSection;
